<div class="container clearfix" (keydown)="loginKeyDown($event)">
  <div class="row">
    <div class="col-md-12">
      <div class="div-svg mt-5 mb-3">
        <img *ngIf="brandImageLoaded" alt="{{'LOGO' | translate}}" class="login-logo" [src]="brandImageUrl">
      </div>
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto" style="margin-top:-40px;max-width:700px"
        [ngClass]="{'mt-5': !brandImageLoaded}">
        <div class="card" [hidden]="resetPassword">
          <div class="card-header pb-2">
            <div class="row">
              <div class="col-12">
                <h4>{{ 'PLEASE-AUTHENTICATE' | translate }}</h4>
              </div>
            </div>
            <!--Show FHIR Link EHR-->
            <div class="row text-left mb-2" *ngIf="showEHRLinkMessage">
              <div class="offset-2 col-8 text-center">
                <i class="fas fa-laptop-medical fa-1_5x" style="position: relative;top: 16px;z-index: 9;"></i>
              </div>
              <div class="offset-2 col-8">
                <div class="p-3" [innerHTML]="'FHIR-LINK-CHANNELS-ACCOUNT' | translate | safe:'html'"
                  style="text-align: justify;text-justify: inter-word;;background-color: #6ba3a5;">
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <form class="k-form" style="padding-bottom:0!important;" role="form" autocomplete="off" #form="ngForm"
              novalidate="">
              <div class="form-group">
                <kendo-floatinglabel text="{{ 'USERNAME' | translate }}">
                  <input #username="ngModel" kendoTextBox autofocus name="username" [(ngModel)]="model.username"
                    (ngModelChange)="resetErrors()" required autocomplete="nope" />
                </kendo-floatinglabel>
                <i class="fas fa-user" aria-hidden="true"></i>
                <div class="validation-error" role="alert" [hidden]="username.valid || !username.touched">
                  {{ 'MUST-ENTER-USERNAME' | translate }}
                </div>
              </div>
              <div class="form-group" style="width:100%; float:left;">
                <kendo-floatinglabel text="{{ 'PASSWORD' | translate }}">
                  <input #password="ngModel" type="password" kendoTextBox name="password" [(ngModel)]="model.password"
                    (ngModelChange)="resetErrors()" required autocomplete="new-password" />
                </kendo-floatinglabel>
                <i class="fas fa-key"></i>
                <div class="validation-error" role="alert" [hidden]="password.valid || !password.touched">{{
                  'MUST-ENTER-PASSWORD' |
                  translate }}</div>
              </div>
              <br />
              <div *ngIf="0" class="form-group" style="width:10%; float:left;">
                <button kendoButton type="button" class="float-center"><i class="fas fa-fingerprint"></i></button>
              </div>
              <br />
              <div *ngIf="isInvalidLogin" role="alert" class="validation-error">{{loginResult}}</div>
              <button kendoButton appPreventClick (click)="login()" [disabled]="!form.valid || authenticating"
                [primary]="true" class="mt-4 float-center k-text-uppercase">
                <span class="pl-2">{{ 'LOGIN' | translate }}</span>
                <i class="far fa-sign-in-alt" *ngIf="!authenticating"></i>
                <i class="k-icon k-i-loading" *ngIf="authenticating"></i>
              </button>
              <div class="row mt-4">
                <div class="col-sm-6">
                  <div class="form-group" style="width:100%; float:left; text-align: left; margin-top: 7px;">
                    <span style="text-align:left;" class="underline keyboard-accessible" (click)="resetPassword = true;"
                      tabindex="0" (keydown.enter)="resetPassword = true;" (keydown.space)="resetPassword = true;">
                      {{ 'FORGOT-PASSWORD' | translate }}
                    </span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <kendo-dropdownlist class="float-right" style="width:240px!important" [data]="loginLanguages"
                    [textField]="'text'" [valueField]="'value'" value="{{selectedLanguage}}" [valuePrimitive]="true"
                    (valueChange)="changeLanguage($event)">
                  </kendo-dropdownlist>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card" [hidden]="!resetPassword">
          <div class="card-header pb-2">
            <div class="row">
              <div class="col-10">
                <h4>{{ 'RESET-PASSWORD' | translate }}</h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <form class="k-form" style="padding-bottom:0;padding-top:0" role="formReset" autocomplete="off"
              #formReset="ngForm" novalidate="">
              <div class="form-group">
                <kendo-floatinglabel text="{{ 'EMAIL' | translate }}">
                  <input #email="ngModel" email kendoTextBox autofocus name="email" [(ngModel)]="modelReset.email"
                    (ngModelChange)="resetErrors()" required autocomplete="nope" />
                </kendo-floatinglabel>
                <i class="fas fa-envelope" aria-hidden="true"></i>
                <div class="validation-error" role="alert" *ngIf="email.invalid && email.touched">
                  {{'WRONG-EMAIL-FORMAT' | translate}}
                </div>
              </div>
              <button appPreventClick kendoButton [disabled]="!formReset.valid" [primary]="true"
                class="mt-4 float-center k-text-uppercase k-reset-button" (click)="sendRequest();">
                {{ 'SEND-REQUEST' | translate }}
                <i class="fas fa-unlock-alt"></i>
              </button>
              <br />
              <br />
              <div class="form-group" style="width:100%; float:left; text-align:left;">
                <span style="text-align:left;" class="underline keyboard-accessible" (click)="resetPassword = false;"
                  tabindex="0" (keydown.enter)="resetPassword = false;" (keydown.space)="resetPassword = false;">{{
                  'BACK-LOGIN' |
                  translate }}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row w-100 h-100 text-right">
    <div class="col" style="color: #fff;vertical-align: bottom;bottom: 10px;position: absolute;"><span
        style="display: inline-flex">
        <div kendoTooltip position="left" class="mr-1 keyboard-accessible" tabindex="0" showOn="none"
          (focus)="showTooltip(resolutionTooltip)" (mouseover)="showTooltip(resolutionTooltip)" (blur)="hideTooltip()"
          (mouseout)="hideTooltip()" aria-live="polite">
          <a #resolutionTooltip title="{{'MINIMUM-RESOLUTION' | translate }}"><i
              class="fa fa-info-circle pointer"></i></a>
        </div>
      </span>
      {{getChannelsEdition()}}&nbsp;&copy;&nbsp;{{ model.version }}
    </div>
  </div>
</div>
<!--Select Active Roles Dialog-->
<app-select-role #selectRole></app-select-role>
<!--Select Active Organizations Dialog-->
<app-select-organization #selectOrganization></app-select-organization>
<!--Change User Password Dialog-->
<app-change-password #changePassword></app-change-password>